import { computed } from 'vue';
import { useAuthStore } from '@/modules/admin/stores/auth';
import { useUserApiStore } from '@/modules/admin/stores/api/user';

export const useUser = () => {
  const authStore = useAuthStore();
  const userApiStore = useUserApiStore();

  const user = computed(() => authStore.user);
  const userLoggedIn = computed(() => !!authStore.user?.role);

  const logout = () => {
    userApiStore.logoutUser();
  };

  return {
    user,
    userLoggedIn,
    logout,
  };
};

